export default "__VITE_ASSET__DX4mg8vr__"